<template>
    <section class="main-box-vc">
        <div class="table-cell home-wrap">
            <div class="main-box">
                <div class="main-box-content">
					<h2 style="color:  #00274c; font-family: 'LibreFranklinRegular';"><b>TITAN PROMENADE TRIBUTE PROGRAM</b></h2>
                    <h4>
                        <center><img class="img-responsive" src="images/aboutbricks.png" alt=""></center>
                    </h4>
                    <router-link to="/about" class="btn btn-danger">GET STARTED</router-link>
                </div>
            </div>
        </div>
    </section>
</template>

<script type="text/jsx">
    export default {
        name: 'home'
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Home.vue?67b6faec